<div>
    <div class="container text-center mt-4 mb-2">
        <img src="./assets/images/logo-ust.svg" alt="logo" class="img-fluid" style="height: 120px;" />
    </div>
</div>
<div style="background-color:#114B43; height:900px">
    <div class="container pt-4 pb-4">
        <fieldset style="background: #eee !important;">

            <form [formGroup]="ChangeForm" novalidate>
                <div class="container" style="background: #9cb93f;">
                    <br>
                    <h2 class="titlex">Restablecer credencial</h2>
                    <h5 class="titlex mb-2">Ingresa la nueva clave para continuar con el proceso de solicitud</h5>
                </div>
                <div class="form">


                    <div class="row mt-2 container">
                        <div class="col-md-12">
                            <label>Clave</label>
                            <input type="password" class="form-control form-control-sm" placeholder="Ingresa tu clave"
                                formControlName="Clave">
                            <span class="text-muted"
                                *ngIf="!ChangeForm.controls['Clave'].valid && ChangeForm.controls['Clave']?.touched">
                                La contraseña debe cumplir con este formato: letras mayúsculas y minúsculas, incluir caracteres (@ , . -) y números. El largo de la credencial debe ser de 8 a 16 caracteres.</span>
                        </div>
                    </div>
                    <div class="row mt-2 container">
                        <div class="col-md-12">
                            <label>Confirmacion Clave</label>
                            <input type="password" class="form-control form-control-sm" placeholder="Confirma tu clave"
                                formControlName="Clave2">
                            <span class="text-muted"
                                *ngIf="!ChangeForm.controls['Clave2'].valid && ChangeForm.controls['Clave2']?.touched">Por
                                favor, ingrese la confirmacion la clave válida</span>
                        </div>
                    </div>
                    <div class="row container mt-2">
                        <div class="col-md-12">

                            <div class="progress" id="progress" *ngIf="progress">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                                    role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                                    style="width: 100%"></div>
                            </div>
                            <div class="alert alert-success alert-dismissible fade show mt-2 lg-success" role="alert"
                                *ngIf="MensajeSucces">
                                <strong>Se ha generado el cambio!</strong> cambio de forma exitosa, llegara un mail con la notificación.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert"
                                *ngIf="MensajeError">
                                <strong>Advertencia!</strong> el enlace ha caducado, Este tiene vigencia de 30 minutos.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row container mt-2">
                        <div class="col-md-12">
                            <button (click)="Solicitud()" class="btn btn-primary btn-block mt-3" id="registrar"
                                style="background-color: #114B43!important; border-color:#114B43;"
                                [disabled]='btnEnviar'>Confirmar</button>
                        </div>
                    </div>
                    <div class="row text-center container mt-2 mb-4">
                        <div class="col-md-12">
                            <a class="text-white mt-1 btn btn-primary btn-block" href="/login"
                                style="cursor:pointer; background-color: #000000;">Volver</a>

                        </div>
                    </div>
                </div>
            </form>
        </fieldset>
    </div>
</div>